import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";

export function LandingCtaBand() {
  const { t } = useTranslation();
  return (
    <section
      className="relative overflow-hidden bg-zinc-950 text-white"
      data-testid="landing-cta-band"
    >
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-violet-500/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-pink-500/30 blur-3xl" />
      <div className="grain pointer-events-none absolute inset-0 opacity-40" />

      <div className="relative mx-auto max-w-4xl px-6 py-20 text-center lg:px-8 lg:py-28">
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-white md:text-5xl">
          {t("landing.cta_band.title")}
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-white/70 md:text-lg">
          {t("landing.cta_band.sub")}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/register">
            <Button
              size="lg"
              className="gap-2 bg-white text-zinc-950 shadow-xl hover:bg-zinc-100"
              data-testid="landing-cta-band-primary"
            >
              {t("landing.cta_band.cta")}
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
          <a href="#pricing">
            <Button
              size="lg"
              variant="ghost"
              className="text-white hover:bg-white/10 hover:text-white"
            >
              {t("landing.pricing.cta")}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
